const ESTATUS_ACTIVO = "A";
const ESTATUS_ACTIVO_LABEL = "Activo";
const ESTATUS_INACTIVO = "I";
const ESTATUS_INACTIVO_LABEL = "Inactivo";

const METODO_PAGO_EFECTIVO = 1;
const METODO_PAGO_CHEQUE_TRANSFERENCIA_DEPOSITO = 2;
const METODO_PAGO_TARJETA = 3;
const METODO_PAGO_VENTA_CREDITO = 4;
const METODO_PAGO_BONO_CERTIFICADO = 5;
const METODO_PAGO_PERMUTA = 6;
const METODO_PAGO_NOTA_CREDITO = 7;
const METODO_PAGO_OTRO = 8;

const METODO_PAGO_EFECTIVO_LABEL = "Efectivo";
const METODO_PAGO_CHEQUE_TRANSFERENCIA_DEPOSITO_LABEL = "Cheque/Transferencia/Depósito";
const METODO_PAGO_TARJETA_LABEL = "Tarjeta de Crédito/Tarjeta de Débito";
const METODO_PAGO_VENTA_CREDITO_LABEL = "Venta a Crédito";
const METODO_PAGO_BONO_CERTIFICADO_LABEL = "Bono/Certificado";
const METODO_PAGO_PERMUTA_LABEL = "Permuta";
const METODO_PAGO_NOTA_CREDITO_LABEL = "Nota de Crédito";
const METODO_PAGO_OTRO_LABEL = "Otras formas de pago";

export class MetodoPago {
  static getMetodoPagoLabel(metodoPago) {
    switch (metodoPago) {
      case METODO_PAGO_EFECTIVO:
        return METODO_PAGO_EFECTIVO_LABEL;
      case METODO_PAGO_CHEQUE_TRANSFERENCIA_DEPOSITO:
        return METODO_PAGO_CHEQUE_TRANSFERENCIA_DEPOSITO_LABEL;
      case METODO_PAGO_TARJETA:
        return METODO_PAGO_TARJETA_LABEL;
      case METODO_PAGO_VENTA_CREDITO:
        return METODO_PAGO_VENTA_CREDITO_LABEL;
      case METODO_PAGO_BONO_CERTIFICADO:
        return METODO_PAGO_BONO_CERTIFICADO_LABEL;
      case METODO_PAGO_PERMUTA:
        return METODO_PAGO_PERMUTA_LABEL;
      case METODO_PAGO_NOTA_CREDITO:
        return METODO_PAGO_NOTA_CREDITO_LABEL;
      case METODO_PAGO_OTRO:
        return METODO_PAGO_OTRO_LABEL;
    }
  }

  static get ESTATUS_LIST() {
    return [
      {
        value: ESTATUS_ACTIVO,
        label: ESTATUS_ACTIVO_LABEL,
      },
      {
        value: ESTATUS_INACTIVO,
        label: ESTATUS_INACTIVO_LABEL,
      },
    ];
  }

  static get METODO_PAGO_LIST() {
    return [
      { value: METODO_PAGO_EFECTIVO, label: METODO_PAGO_EFECTIVO_LABEL },
      { value: METODO_PAGO_CHEQUE_TRANSFERENCIA_DEPOSITO, label: METODO_PAGO_CHEQUE_TRANSFERENCIA_DEPOSITO_LABEL },
      { value: METODO_PAGO_TARJETA, label: METODO_PAGO_TARJETA_LABEL },
      { value: METODO_PAGO_VENTA_CREDITO, label: METODO_PAGO_VENTA_CREDITO_LABEL },
      { value: METODO_PAGO_BONO_CERTIFICADO, label: METODO_PAGO_BONO_CERTIFICADO_LABEL },
      { value: METODO_PAGO_PERMUTA, label: METODO_PAGO_PERMUTA_LABEL },
      { value: METODO_PAGO_NOTA_CREDITO, label: METODO_PAGO_NOTA_CREDITO_LABEL },
      { value: METODO_PAGO_OTRO, label: METODO_PAGO_OTRO_LABEL },
    ];
  }

  static get DEFAULT_ESTATUS_VALUE() {
    return ESTATUS_ACTIVO;
  }

  static get PROPIEDADES_EXPORTAR() {
    const propiedades = [
      { value: "IdSec", label: "Id" },
      { value: "Nombre", label: "Nombre" },
      { value: "TipoMetodoPagoDesc", label: "Tipo de Pago" },
      { value: "EstatusDesc", label: "Estatus" },
      { value: "CrearUsuario", label: "Crear Usuario" },
      { value: "FechaCreacion", label: "Fecha Creación" },
      { value: "ActualizarUsuario", label: "Actualizar Usuario" },
      { value: "FechaActualizacion", label: "Fecha Actualización" },
    ];
    return propiedades.sort((a, b) => (a.label > b.label ? 1 : -1));
  }
}
